import * as Sentry from "@sentry/react";

import { ApiError } from "@/lib/api";

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    release: import.meta.env.VITE_RELEASE,
    sendDefaultPii: false,
    // Thrown by scripts that email-security link scanners (Outlook SafeLinks
    // et al., built on CefSharp) inject into pages they crawl — not our code.
    ignoreErrors: [
      /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/,
    ],
    beforeSend(event, hint) {
      // 4xx responses are expected business errors (validation, expired
      // session, missing object) handled in the UI; only 5xx and network
      // failures warrant an alert.
      const error = hint.originalException;
      if (error instanceof ApiError && error.status < 500) {
        return null;
      }
      return event;
    },
  });
}

export function reportError(error: unknown, extra?: Record<string, unknown>) {
  if (!dsn) return;
  if (error instanceof ApiError && error.status < 500) return;
  Sentry.captureException(error, extra ? { extra } : undefined);
}

export function setSentryUser(userId: number | null) {
  if (!dsn) return;
  Sentry.setUser(userId === null ? null : { id: String(userId) });
}

export { Sentry };
